(function (window) {
  'use strict';

  class tradeAppApi {
    constructor(action, demo = false) {
      this._demo = demo;
      this._url = (!demo && action) || null;

      this._minTimeout = 400;
      this._endpoints = {
        getLocations: {
          method: 'GET',
          url: '/v1/location'
        },
        createOrder: {
          method: 'POST',
          url: '/v1/order'
        }
      };

      if(this._demo) {
        this._defaultStores = {
          status: "success",
          data: [
            {
              id: 1,
              locationId: 384760,
              name: "ILLINOIS EYE CENTER",
              distance: 1.88,
              distanceUnit: "mi",
              address: "8921 N WOOD SAGE RD, PEORIA, US-IL, 61615, United States",
              geoLocation: {
                type: "Point",
                coordinates: [40.796677, -89.668176]
              },
              zipCode: "61615",
              prescriptionRetailer: true
            },
            {
              id: 2,
              locationId: 464312,
              name: "BOB LINDSAY ACURA",
              distance: 1.93,
              distanceUnit: "mi",
              address: "7500 N ALLEN RD, PEORIA, US-IL, 61614, United States",
              geoLocation: {
                type: "Point",
                coordinates: [40.778679, -89.630239]
              },
              zipCode: "61614",
              prescriptionRetailer: false
            },
            {
              id: 3,
              locationId: 502200,
              name: "LEXUS OF PEORIA",
              distance: 2.03,
              distanceUnit: "mi",
              address: "7301 N ALLEN RD, PEORIA, US-IL, 61614, United States",
              geoLocation: {
                type: "Point",
                coordinates: [40.776949, -89.632447]
              },
              zipCode: "61614",
              prescriptionRetailer: false
            }
          ]
        };

        this._defaultEmptyStores = {
          status: "success",
          data: []
        };

        this._defaultConfirmation = {
          status: "success",
          data: {
            orderId: 15548459
          }
        };

        this._defaultError = {
          status: "error",
          error: {
            code: 1,
            message: "Unexpected error."
          }
        };
      } else {
        this._customerIP = window.tradeAppApiConfig.customerIP;
        this._locale = window.tradeAppApiConfig.locale;
        this._countryCode = window.tradeAppApiConfig.countryCode;
        this._trackingId = window.tradeAppApiConfig.trackingId;
        this._token = window.tradeAppApiConfig.token;
        this._ajaxTimeout = window.tradeAppApiConfig.ajaxTimeout;
      }
    }

    // Getter and Setters
    get sku() {
      return (typeof this._sku === "undefined" || this._sku === "" || this._sku === null) ? null : this._sku;
    }

    set sku(sku) {
      this._sku = sku;
    }

    get locationId() {
      return (typeof this._locationId === "undefined" || this._locationId === "" || this._locationId === null) ? null : this._locationId;
    }

    set locationId(locationId) {
      this._locationId = locationId;
    }

    get locationName() {
      return (typeof this._locationName === "undefined" || this._locationName === "" || this._locationName === null) ? null : this._locationName;
    }

    set locationName(locationName) {
      this._locationName = locationName;
    }

    get locationAddress() {
      return (typeof this._locationAddress === "undefined" || this._locationAddress === "" || this._locationAddress === null) ? null : this._locationAddress;
    }

    set locationAddress(locationAddress) {
      this._locationAddress = locationAddress;
    }

    get customer() {
      return (typeof this._customer === "undefined" || this._customer === {} || this._customer === null) ? null : this._customer;
    }

    set customer(customer) {
      this._customer = customer;
    }

    get zipCode() {
      return (typeof this._zipCode === "undefined" || this._zipCode === "" || this._zipCode === null) ? null : this._zipCode;
    }

    set zipCode(zipCode) {
      this._zipCode = zipCode;
    }

    set variation(variation) {
      this._variation = variation;
    }

    getLocations(succeed, fail) {
      this._start = Date.now();

      if (this._demo === true) {
        switch(this._zipCode) {
          case "61615":
            setTimeout(() => succeed(this._defaultStores), this._minTimeout);
            break;
          case "12345":
            setTimeout(() => fail(this._defaultError), this._minTimeout);
            break;
          default:
            setTimeout(() => succeed(this._defaultEmptyStores), this._minTimeout);
            break;
        }
      } else {
        const endpoint = this._endpoints.getLocations;
        const url = `${endpoint.url}?sku=${encodeURIComponent(this._sku)}&zipCode=${encodeURIComponent(this._zipCode)}&countryCode=${encodeURIComponent(this._countryCode)}`;

        try {
          // If the dataLayer object is defined and a push method is defined on it
          if (typeof window.dataLayer === "object" && typeof window.dataLayer.push === "function") {
            // Register a Google Tag Manager action indicating an availability search was run
            window.dataLayer.push({
              'event': 'ropisSearch',
              'ropisZip': this._zipCode // The zip code for which the search was run
            });
          }
        } catch (e) {}

        this._queryApi(url, endpoint.method, null, response => {
          for(let i = 0; i < response.data.length; i++) {
            response.data[i].distance = parseFloat(response.data[i].distance.toFixed(2));
            response.data[i].distanceUnit = response.data[i].distanceUnit.toLowerCase();
          }
          succeed(response);
        }, fail);
      }
    }

    createOrder(succeed, fail) {
      this._start = Date.now();

      if (this._demo === true) {
        if(this._customer.firstName === "Error" && this._customer.lastName === "Error") {
          setTimeout(() => fail(this._defaultError), this._minTimeout);
        } else {
          setTimeout(() => succeed(this._defaultConfirmation), this._minTimeout);
        }
      } else {
        const endpoint = this._endpoints.createOrder,
          payload = {
            sku: this._sku,
            locationId: this._locationId,
            firstName: this._customer.firstName,
            lastName: this._customer.lastName,
            email: this._customer.email,
            phone: this._customer.phone,
            customItemData: {
              frame: this._variation.frame,
              image: this._variation.image,
              lens: this._variation.lens,
              style: this._variation.style,
              url: this._variation.url
            },
            customOrderData: {
              countryCode: this._countryCode,
              customerIP: this._customerIP,
              locale: this._locale,
              subscribe: this._customer.subscribe,
              trackingId: this._trackingId,
              zipCode: this._zipCode
            },
          };

        this._queryApi(endpoint.url, endpoint.method, payload, response => {

          try {
            // If the dataLayer object is defined and a push method is defined on it
            if (typeof window.dataLayer === "object" && typeof window.dataLayer.push === "function") {
              // Register a Google Tag Manager action indicating the reservation was successfully placed
              window.dataLayer.push(
                {
                  'event': 'ropisReserve',
                  'transactionID': response.data.orderID + "", // The reservation ID returned by the Trade App server
                  'ropisSKU': this._sku, // The reserved sku
                  'ropisPrice': null, // This is temporarily being passed as null due to the online price not reflecting the in-store price
                  'ropisStoreName': this._locationName, // The name of the location against which he reservation was placed
                  'ropisStoreLocation': this._locationAddress // The address of the location against which the reservation was placed
                }
              );
            }
          } catch (e) {}

          succeed(response);
        }, fail);
      }
    }

    _queryApi(url, method, payload, succeed, fail) {
      const xhr = new XMLHttpRequest();

      xhr.open(method, `${this._url}${url}`, true);
      xhr.timeout = this._ajaxTimeout;

      if (method === 'POST' || method === 'PUT' || method === 'PATCH') {
        xhr.setRequestHeader('Content-Type', 'application/json');
      }

      xhr.setRequestHeader('Authorization', `Bearer ${this._token}`);

      xhr.onload = () => {
        const timeout = Math.max(this._minTimeout - (Date.now() - this._start), 0);
        switch(parseInt((xhr.status))) {
          case 200:
          case 201:
          case 202:
          case 204:
            setTimeout(() => succeed(JSON.parse(xhr.responseText)), timeout);
            break;
          default:
            setTimeout(fail, timeout);
            break;
        }
      };

      xhr.onerror = xhr.ontimeout = () => {
        const timeout = Math.max(this._minTimeout - (Date.now() - this._start), 0);
        setTimeout(fail, timeout);
      };

      xhr.send(payload !== null ? JSON.stringify(payload) : null);
    }
  }

  const form = document.querySelector('form.modal-form--reserve-in-store');
  if(form) {
    const action = form.getAttribute('action');
    const demo = (action === "8f6ce88d42dd6b994dd53f53149d089a");

    if(window.hasOwnProperty('tradeAppApiConfig') || demo) {
      window.tradeAppApi = new tradeAppApi(action, demo);
    }
  }

})(this);
